import { adminHttpClient } from '../../commons/adminHttpClient'
import { ProductClass } from './getBenefitDetails'

export interface BenefitDetailsForClass {
  id: string
  startDate: Date
  endDate: Date
  createdOn: Date
  createdBy: string
  sameClassForAll: boolean
  classes: ProductClass[]
  runOutDate: Date
}

const getBenefitClasses = (planPeriodId: string): Promise<BenefitDetailsForClass> => {
  return adminHttpClient.get(`/csi/Companies/benefit/${planPeriodId}/classes`)
}

export default getBenefitClasses
